import _ from 'underscore';
import getConfig from 'next/config';
import { getEntityUrl } from './cultureUtils';

const { publicRuntimeConfig } = getConfig();

export const makeBaseUrl = ({ protocol, hostname, port }) =>
	`${protocol}//${hostname}:${port}`;

export const cultureUrl = makeBaseUrl(
	publicRuntimeConfig.services.frontend.main
);

export const filterQuery = (query) =>
	_(query).reduce((memo, value, key) => {
		let param = {};

		if (value !== undefined && value !== '' && value !== null) {
			param = { [key]: value };
		}

		return { ...memo, ...param };
	}, {});

export const getQueryObject = (url) => {
	const urlObject = new URL(url);

	return urlObject.searchParams;
};

export const addQuery = (url, queryObject) => {
	let urlString = url;

	if (urlString.startsWith('//')) {
		urlString = `https:${urlString}`;
	}
	const urlObject = new URL(urlString, publicRuntimeConfig.baseUrl);

	_(queryObject).each((value, name) => {
		if (value) {
			urlObject.searchParams.set(name, value);
		} else {
			urlObject.searchParams.delete(name);
		}
	});

	return urlString.startsWith(urlObject.origin)
		? urlObject.toString()
		: `${urlObject.pathname}${urlObject.search}`;
};

export const getQueryString = (queryObject) => {
	const searchParams = new URLSearchParams(filterQuery(queryObject));

	return searchParams.toString();
};

export const canonicalUrlsHash = [
	{
		template: _.template('/<%=locationName%>?tags=<%=tags[0]%>'),
		condition(params) {
			return (
				params.locationName &&
				params.tags &&
				!params.genre &&
				!params.period &&
				!params.seanceStartDate &&
				!params.seanceEndDate
			);
		}
	},
	{
		template: _.template('/<%=locationName%>/<%=genre%>?period=<%=period%>'),
		condition(params) {
			return (
				params.locationName &&
				params.period &&
				params.genre &&
				!params.tags &&
				!params.seanceStartDate &&
				!params.seanceEndDate
			);
		}
	},
	{
		template: _.template('/<%=locationName%>?period=<%=period%>'),
		condition(params) {
			return (
				params.locationName &&
				params.period &&
				!params.genre &&
				!params.tags &&
				!params.seanceStartDate &&
				!params.seanceEndDate
			);
		}
	},
	// default canonicals
	{
		template: _.template('/<%=locationName%>/<%=genre%>'),
		condition(params) {
			return params.locationName && params.genre;
		}
	},
	{
		template: _.template('/<%=locationName%>'),
		condition(params) {
			return params.locationName;
		}
	}
];

export const getTargetCanonical = (params) => {
	const canonicalUrl = _(canonicalUrlsHash).find((url) =>
		url.condition(params)
	);

	if (canonicalUrl) {
		return canonicalUrl.template(params);
	}

	return '';
};

export const getCanonicalUrl = (params) => {
	let url = '';

	if (params.rubric) {
		url = `${publicRuntimeConfig.baseUrl}/${params.rubric.path}`;
	} else if (params.entity && params.entityType) {
		url = `${publicRuntimeConfig.baseUrl}${getEntityUrl(
			params.entityType,
			params.entity
		)}`;
	}

	if (params.urlParams) {
		url += getTargetCanonical(params.urlParams);
	}

	return url;
};
